import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, useTheme, Card, CardContent, Grid, CircularProgress } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../config";

const Settings = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [settings, setSettings] = useState({
    google_maps_api_key: "",
    base_fare: "100",
    commission_rate: "0.10",
    version: "1.0.0",
    version2: "1.0.0",
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const fetchSettings = async () => {
    setLoading(true);
    try {
      const authToken = sessionStorage.getItem("authToken");
      const res = await fetch(`${API_BASE_URL}/admin/settings`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ authToken }),
      });
      const data = await res.json();
      if (data.success && data.settings) {
        setSettings((prev) => ({ ...prev, ...data.settings }));
      }
    } catch (err) {
      console.error("Erreur chargement settings:", err);
      toast.error("Erreur de chargement des paramètres");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettings((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const authToken = sessionStorage.getItem("authToken");
      const res = await fetch(`${API_BASE_URL}/admin/settings/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ authToken, settings }),
      });
      const data = await res.json();
      if (data.success) {
        toast.success("Paramètres et clé Maps enregistrés avec succès !");
      } else {
        toast.error(data.message || "Erreur de sauvegarde");
      }
    } catch (err) {
      console.error("Erreur sauvegarde settings:", err);
      toast.error("Erreur lors de la sauvegarde des paramètres");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box m="20px" display="flex" justifyContent="center" alignItems="center" height="60vh">
        <CircularProgress color="secondary" />
      </Box>
    );
  }

  return (
    <Box m="20px">
      <Header title="PARAMÈTRES SYSTÈME" subtitle="Configuration globale de l'écosystème LinkerVTC" />

      <form onSubmit={handleSave}>
        <Grid container spacing={3} mt="10px">
          {/* Section Google Maps API Key */}
          <Grid item xs={12}>
            <Card sx={{ backgroundColor: colors.primary[400] }}>
              <CardContent>
                <Typography variant="h5" color={colors.greenAccent[500]} fontWeight="bold" mb="10px">
                  Clé API Google Maps (Configurable en temps réel)
                </Typography>
                <Typography variant="body2" color={colors.grey[300]} mb="15px">
                  Cette clé est diffusée dynamiquement aux applications mobiles LinkerVTC et à l'admin panel.
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Google Maps API Key"
                  name="google_maps_api_key"
                  value={settings.google_maps_api_key || ""}
                  onChange={handleChange}
                  placeholder="AIzaSy..."
                  helperText="Exemple : AIzaSyDnDFcEd8Z49W8O7H8eNFNQ2-4fK79LMiA"
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Section Tarification & Commission */}
          <Grid item xs={12} md={6}>
            <Card sx={{ backgroundColor: colors.primary[400] }}>
              <CardContent>
                <Typography variant="h5" color={colors.greenAccent[500]} fontWeight="bold" mb="15px">
                  Tarification & Commission
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Prise en charge de base (DZD)"
                  name="base_fare"
                  value={settings.base_fare || "100"}
                  onChange={handleChange}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Taux de Commission Plateforme (0.10 = 10%)"
                  name="commission_rate"
                  value={settings.commission_rate || "0.10"}
                  onChange={handleChange}
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Section Versions Mobiles */}
          <Grid item xs={12} md={6}>
            <Card sx={{ backgroundColor: colors.primary[400] }}>
              <CardContent>
                <Typography variant="h5" color={colors.greenAccent[500]} fontWeight="bold" mb="15px">
                  Versions Requises des Applications
                </Typography>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Version Min. Application Client"
                  name="version"
                  value={settings.version || "1.0.0"}
                  onChange={handleChange}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Version Min. Application Chauffeur"
                  name="version2"
                  value={settings.version2 || "1.0.0"}
                  onChange={handleChange}
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Bouton de sauvegarde */}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end" mt="10px">
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={saving}
                sx={{
                  padding: "12px 30px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  backgroundColor: colors.greenAccent[600],
                  "&:hover": { backgroundColor: colors.greenAccent[700] },
                }}
              >
                {saving ? "Sauvegarde en cours..." : "Enregistrer les modifications"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default Settings;
